let scriptLoaded = false;

const activityEvents = [
  "mousedown",
  "mousemove",
  "keydown",
  "scroll",
  "touchstart",
  "click",
  "keypress",
  "touchmove",
];

function loadJSscripts() {
  if (scriptLoaded) {
    return;
  }

  scriptLoaded = true;

  // Disconnect the lazy-loading observer if it exists.
  if (
    typeof window.uLTS !== "undefined" &&
    window.uLTS &&
    typeof window.uLTS.disconnect === "function"
  ) {
    window.uLTS.disconnect();
  }

  // Unblock scripts managed by Yett, if present.
  if (
    typeof window.yett !== "undefined" &&
    typeof window.yett.unblock === "function"
  ) {
    window.yett.unblock();
  }

  // Load deferred iframes and external scripts.
  document
    .querySelectorAll("iframe[data-src], script[data-src]")
    .forEach((element) => {
      const dataSrc = element.dataset.src;

      if (dataSrc) {
        element.src = dataSrc;
        delete element.dataset.src;
      }
    });

  // Load deferred stylesheets.
  document.querySelectorAll("link[data-href]").forEach((link) => {
    const dataHref = link.dataset.href;

    if (dataHref) {
      link.href = dataHref;
      delete link.dataset.href;
    }
  });

  // Activate deferred inline scripts.
  document
    .querySelectorAll('script[type="text/lazyload"]')
    .forEach((lazyScript) => {
      const activeScript = document.createElement("script");

      Array.from(lazyScript.attributes).forEach((attribute) => {
        if (attribute.name !== "type") {
          activeScript.setAttribute(attribute.name, attribute.value);
        }
      });

      activeScript.type = "text/javascript";
      activeScript.textContent = lazyScript.textContent;

      lazyScript.replaceWith(activeScript);
    });

  // Remove interaction listeners because loading only needs to happen once.
  activityEvents.forEach((eventName) => {
    window.removeEventListener(eventName, loadJSscripts);
  });

  document.dispatchEvent(new CustomEvent("asyncLazyLoad"));

  window.setTimeout(() => {
    document.dispatchEvent(new CustomEvent("loadBarInjector"));
  }, 3000);
}

activityEvents.forEach((eventName) => {
  window.addEventListener(eventName, loadJSscripts, {
    passive: true,
  });
});

// Load immediately unless PSA mode is explicitly enabled.
if (typeof window.__isPSA === "undefined" || !window.__isPSA) {
  loadJSscripts();
}